import React, { useState } from 'react';
import {
  View,
  Image,
  StyleSheet,
  Text,
  ImageSourcePropType,
} from 'react-native';

import colors from 'shared/modules/common/constants/colors';
import typography from 'shared/modules/common/constants/typography';

type Props = {
  deviceName: string;
  imageSrc: ImageSourcePropType;
};

export default function DeviceDetails({ deviceName, imageSrc }: Props) {
  const [image, setImage] = useState(imageSrc);

  return (
    <View style={styles.container}>
      <Image
        style={styles.image}
        source={image}
        onError={() =>
          setImage(
            require('shared/assets/images/apple-item-placeholder@3x.png')
          )
        }
      />
      <Text style={styles.title}>{deviceName}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    flex: 1,
    ...typography.title03,
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 24,
    color: colors.greyDark,
  },
  image: {
    width: 64,
    height: 64,
    marginRight: 9,
    resizeMode: 'contain',
  },
});
